export default function Swapper({on, off}) {
    
    return (
        <label className="swap">
            <input type="checkbox" />
            <div className="swap-on btn btn-success btn-info ">{on}</div>
            <div className="swap-off btn btn-success btn-error">{off}</div>
        </label>
    )
}